<template>
  <div
    class="flex max-w-min cursor-pointer items-center gap-2 rounded-sm border p-2"
    :class="isSelected ? 'selected' : 'border-gray-200 bg-white'"
    :data-cy
  >
    <slot name="prefix" />
    <div
      class="flex items-center gap-x-1"
      :class="isSelected ? 'text-primary' : 'text-gray-400'"
    >
      <span
        class="'max-w-xs font-semibold' truncate text-xs"
        :class="{ 'text-gray-500': !isSelected }"
      >
        {{ text }}
      </span>
      <template v-if="ownershipStake">
        <div class="text-xs font-semibold">•</div>
        <div
          class="text-xxs whitespace-nowrap uppercase relative top-0.5"
          data-cy="company-ownership"
        >
          {{
            $t("DEALS.DEAL_PROGRESS.SIGNED.COMPANY_OWNERSHIP", {
              percent: ownershipStake,
            })
          }}
        </div>
      </template>
    </div>
    <div
      v-if="showCheckmark"
      :class="isSelected ? 'text-primary' : 'text-gray-400'"
    >
      <icon-base :icon="IconSuccessRoundBig" />
    </div>
  </div>
</template>

<script setup lang="ts">
import IconSuccessRoundBig from "@/components/icons/IconSuccessRoundBig.vue";

defineProps({
  isSelected: {
    type: Boolean,
    required: true,
  },
  ownershipStake: {
    type: [String, Number],
  },
  showCheckmark: {
    type: Boolean,
    default: false,
  },
  text: {
    type: String,
    required: true,
  },
  dataCy: {
    type: String,
    default: "",
  },
});
</script>

<style scoped>
@reference "@/assets/tailwind.css";

.selected {
  @apply border-transparent bg-primary/10 hover:bg-primary/15;
}
</style>
